export class BreadcrumbModel {
    constructor(
        public id: string,
        public title: string,
    ) {
    }
}
